import styled from "styled-components";

export const Wrapper = styled.nav`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 28px;
`;

export const Menu = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;

  display: flex;
  li:not(:last-child) {
    border-right: 1px solid;
  }
  padding-right: 10px;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const MenuItem = styled.li`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  svg {
    width: 20px;
  }
`;

export const Menulink = styled.a`
  padding: 0 14px;
  cursor: pointer;
  letter-spacing: 0.2em;
  font-size:0.8em;

  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
`;
